import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';

import type {
  TextEffectsSharedDefinition,
  TextEffectsSharedMapperProps,
} from '../TextEffectsShared.types';
import { castFromInheritIfNeeded } from '@wix/editor-elements-common-utils';

export const props = withCompInfo<
  TextEffectsSharedMapperProps,
  TextEffectsSharedDefinition
>()(
  ['compData', 'language', 'directionWithOptInRtlSupport', 'isInSeo'],
  ({ compData, language, directionWithOptInRtlSupport, isInSeo }) => {
    const textDirection = castFromInheritIfNeeded(
      compData?.textDirection ?? 'inherit',
      directionWithOptInRtlSupport,
    );
    return {
      ...compData,
      patternScope: isInSeo ? 'none' : compData?.patternScope,
      language,
      textDirection,
    };
  },
);

export const stateRefs = withStateRefsValues(['reducedMotion', 'experiments']);

export default createComponentMapperModel({
  props,
  stateRefs,
});
